export default "__VITE_ASSET__6d8204fe__"